import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function SmackFeature() {
  return (
    <section className="smack_feature p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/smackback/features_img.webp"
              alt="smackback TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={850}
              height={827}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            className="my-auto  order-md-2 order-1"
          >
            <h2>The App’s Starred Highlighted Features</h2>
            <p>
              The USP of Smackback lies in the unprecedented convenience it
              offers to its users. With a range of features and user-friendly
              functionality, this app is a comprehensive communication tool that
              automates the task of answering phone calls and text messages.
            </p>
            <p>
              That said, here’s why Smackback isn’t just another messaging app:
            </p>
            <ul className="list_items">
              <li>
                <div className="count">01</div>
                <div>
                  Create a profile, schedule text messages to be sent at a later
                  time, build personalized contact lists and set up customized
                  messages for each of them.
                </div>
              </li>
              <li>
                <div className="count">02</div>
                <div>
                  Read incoming messages and automatically respond with a
                  pre-defined custom text message, without direct user input.
                </div>
              </li>
              <li>
                <div className="count">03</div>
                <div>
                  Connects with Bluetooth systems in your car, headphones, or
                  other devices and automatically responds with a custom
                  message, informing whoever reaches out to you at the time that
                  you’re currently driving, on a treadmill or engaged in other
                  activities as per your instructions.
                </div>
              </li>
              <li>
                <div className="count">04</div>
                <div>
                  Integrates with your calendar and enables you to experience
                  the real power of automation.
                </div>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SmackFeature;
